const VTO_CONTAINER_ID = 'revieve-container';
const VTO_TOGGLE_TEXT = 'Virtual Try On';
const GENERIC_ERROR_MESSAGE = 'There was a problem loading Virtual Try On';
const COLOR_UNAVAILABLE_MESSAGE = 'This color is not available for Virtual Try On';
const COLOR_UNAVAILABLE = 'COLOR_UNAVAILABLE';
export {
    VTO_CONTAINER_ID,
    VTO_TOGGLE_TEXT,
    GENERIC_ERROR_MESSAGE,
    COLOR_UNAVAILABLE_MESSAGE,
    COLOR_UNAVAILABLE,
};
